import { StrictMode } from "react";
import * as ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import getRoutes from "./Routes";
import "./style/style.css";
import * as Sentry from "@sentry/react";

let dsn = import.meta.env.VITE_SENTRY_DSN;
if (!dsn) {
  throw new Error("Sentry DSN is not defined in the environment variables.");
}
Sentry.init({
  dsn,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
});

ReactDOM
  .createRoot(document.getElementById("root"))
  .render(
    <StrictMode>
      <Sentry.ErrorBoundary fallback={<div>An error has occurred</div>}>
        <RouterProvider router={getRoutes()} />
      </Sentry.ErrorBoundary>
    </StrictMode>)